export default "/kiban/_next/static/images/alert-3567dcd3d23db4374157c08b52607bbf.svg";